import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'

const Block = styled.div`
  display: flex;
  align-items: center;
  margin-right: -${sv.spacing.usmall};

  > * {
    padding-right: ${sv.spacing.usmall};
  }
`

export default { Block }
